<div *ngIf="apiLoaded && mapCenter && zoom && medicalCenters">
    <google-map [center]="mapCenter" [zoom]="zoom" [width]="null">
        <map-marker
            #marker="mapMarker"
            *ngFor="let medicalCenter of medicalCenters"
            (mapClick)="handleMarkerClick(medicalCenter, marker, true)"
            [position]="getLatLngLitteral(medicalCenter.coordonneesGps)"
            [icon]="getMarkerIcon(medicalCenter)"
        >
        </map-marker>
        <map-info-window>
            <div class="appointment-planner__body__planner-result__appointments__item appointment-planner__body__planner-result__appointments__item--tooltip">
                <app-center-details-component
                    #centerDetails
                    *ngIf="selectedCenter"
                    [center]="selectedCenter"
                    [telephone]="telephone"
                    [idDossierMedical]="idDossierMedical"
                    (callBack)="callBack.emit($event)"
                    (appointmentClicked)="appointmentClicked.emit($event)"
                >
                </app-center-details-component>
            </div>
        </map-info-window>
    </google-map>
    <div class="map-legend">
        <div class="map-legend__label"><span class="map-legend__icon green"></span> RDV en ligne</div>
        <div class="map-legend__label"><span class="map-legend__icon pink"></span> RDV par téléphone</div>
    </div>
</div>
